import React, { FC } from "react";
import { Routes, Route } from "react-router-dom";
import OrderManagementList from "./OrderManagementList";
import { Role } from "common/Constants";
import ProtectedRoute from "common/ProtectedRoute";

export const OrderManagementRouter: FC<{}> = () => {
  return (
    <Routes>
      <Route index element={ <ProtectedRoute roles={[Role.Admin, Role.TripAdmin, Role.Dispatcher]}><OrderManagementList /></ProtectedRoute>} />
    </Routes>
  );
};
